<template>
  <section>
    <h4
      aria-hidden="true"
      class="mt-3"
    >
      Par service avec emblème Font Awesome
    </h4>
    <b-row aria-hidden="true">
      <b-col lg="8">
        <b-card bg-variant="light border rounded mb-3">
          <p>
            Les icônes sont générées dynamiquement en javascript à partir d’un
            template <abbr>SVG</abbr>.
          </p>

          <b-form
            novalidate
            @submit.stop.prevent="svg2png('round');svg2png('fav');"
          >
            <b-form-group label="Couleur">
              <b-form-radio-group
                v-model="color"
                buttons
                class="col p-0 mr-n1"
                :button-variant="`block btn-light border-0 rounded m-1`"
              >
                <b-form-radio
                  :value="{ border: '#725794', bec: '#dd6418', variant: 'primary' }"
                >
                  <i class="fas fa-circle fc-f7"></i>
                  Violet
                </b-form-radio>
                <b-form-radio
                  :value="{ border: '#dd6418', bec: '#dd6418', variant: 'warning' }"
                >
                  <i class="fas fa-circle fc-o6"></i>
                  Orange
                </b-form-radio>
                <b-form-radio
                  :value="{ border: '#c42719', bec: '#c42719', variant: 'danger' }"
                >
                  <i class="fas fa-circle fc-r8"></i>
                  Rouge
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group label="Icône">
              <b-input-group>
                <b-form-input
                  v-model="icon.fa"
                  type="text"
                  class="fb-g1 border-0"
                  @focusout="fetchSVG()"
                />

                <b-input-group-append>
                  <b-button
                    type="submit"
                    :variant="color.variant"
                  >
                    Créer les images png
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>

      <b-col
        id="pinchots"
        lg="4"
        class="p-0 d-flex d-lg-block"
      >
        <b-col
          cols="6"
          lg="12"
        >
          <h5>
            SVG
          </h5>
          <div class="mx-auto mb-3 justify-content-around align-items-center d-flex">
            <a
              id="svg_round"
              ref="svg_round"
              href="#"
              download="apple-touch-icon.svg"
              @click="downloadSVG('svg_round')"
            >
              <SVGPinchot
                :icon="icon"
                :color="color"
              />
            </a>
            <a
              id="svg_fav"
              ref="svg_fav"
              href="#"
              download="favicon.svg"
              @click="downloadSVG('svg_fav')"
            >
              <SVGFavicon
                :icon="icon"
                :color="color"
              />
            </a>
          </div>
        </b-col>

        <b-col
          cols="6"
          lg="12"
        >
          <h5>
            PNG
          </h5>
          <div class="fb-g2 mx-auto mb-3 p-2 justify-content-around align-items-center d-flex">
            <a
              id="png_round"
              ref="png_round"
              href="#"
              download="apple-touch-icon.png"
              @click="download('canvas_round')"
            >
              <canvas
                id="canvas_round"
                ref="canvas_round"
                width="120"
                height="120"
              ></canvas>
            </a>
            <a
              id="png_fav"
              ref="png_fav"
              href="#"
              download="favicon.png"
              @click="download('canvas_fav')"
            >
              <canvas
                id="canvas_fav"
                ref="canvas_fav"
                width="32"
                height="32"
              ></canvas>
            </a>
          </div>
        </b-col>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import SVGPinchot from './SVGPinchot.vue';
import SVGFavicon from './SVGFavicon.vue';

export default {
  components: {
    SVGPinchot,
    SVGFavicon,
  },

  data() {
    return {
      color: {
        border: '#725794',
        bec: '#dd6418',
        variant: 'primary',
      },
      icon: {
        fa: 'bicycle',
        svg: '',
      },
    };
  },

  mounted() {
    this.fetchSVG();
  },

  methods: {
    svg2png(id) {
      const canvas = this.$refs[`canvas_${id}`];
      const ctx = canvas.getContext('2d');
      const img = new Image();
      const svg = new Blob([this.$refs[`svg_${id}`].innerHTML], {
        type: 'image/svg+xml;charset=utf-8',
      });
      const url = window.self.URL.createObjectURL(svg);
      img.onload = () => { ctx.drawImage(img, 0, 0); };
      img.src = url;
    },

    fetchSVG() {
      fetch(`https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/${this.icon.fa}.svg`)
        .then(res => res.text())
        .then((data) => {
          this.icon.svg = data;
        })
        .catch((err) => { console.error(err); }); // eslint-disable-line
    },

    download(file) {
      this.$refs[file.replace('canvas', 'png')].href = this.$refs[file].toDataURL();
      this.$refs[file.replace('canvas', 'png')].click();
    },

    downloadSVG(file) {
      this.$refs[file].href = `data:image/svg+xml;base64,${btoa(this.$refs[file].innerHTML)}`;
      this.$refs[file].click();
    },
  },
};
</script>
